import { SxProps, Theme } from "@mui/material";

export const containerStyle: SxProps<Theme> = (theme) => ({
  backgroundColor: theme.palette.quizPopap.quizInsideBg,
  p: { xs: 2, sm: 4, md: 6 },
  borderRadius: "24px",
  width: "100%",
  boxSizing: "border-box",
});

export const headerContainerStyle: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

export const statisticTitleStyle: SxProps<Theme> = {
  fontWeight: 600,
  color: "#06B6D4",
  fontSize: "16px",
};

export const congratulationTextStyle: SxProps<Theme> = (theme) => ({
  fontWeight: 700,
  color: theme.palette.quizPopap.quizText,
  fontSize: "18px",
  mb: "24px",
});

export const dividerContainerStyle: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
};

export const dividerStyle: SxProps<Theme> = (theme) => ({
  my: 4,
  maxWidth: "424px",
  width: "100%",
  flex: 1,
  borderColor: theme.palette.quizPopap.quizSeparator,
  borderBottomWidth: "1px",
});

export const timeContainerStyle: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

export const timeTextStyle: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 1,
  fontSize: "16px",
  fontWeight: 500,
  backgroundColor: theme.palette.quizPopap.quizeGraf,
  px: { xs: 2, sm: 4, md: "88px" },
  py: "16px",
  borderRadius: "8px",
  color: theme.palette.quizPopap.quizText,
  width: "100%",
  maxWidth: "424px",
  boxSizing: "border-box",
});

export const timeLabelStyle: SxProps<Theme> = {
  fontSize: { xs: "14px", sm: "16px" },
  fontWeight: 500,
  textAlign: "center",
  whiteSpace: "nowrap",
};

export const timeSegmentsRowStyle: SxProps<Theme> = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  gap: 0.5,
};

export const timeSegmentStyle: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  minWidth: "28px",
};

export const timeSegmentValueStyle: SxProps<Theme> = {
  fontSize: "18px",
  fontWeight: 800,
  lineHeight: 1.2,
};

export const timeSegmentLabelStyle: SxProps<Theme> = {
  fontSize: "12px",
  fontWeight: 500,
  lineHeight: 1.2,
  mt: 0.25,
  opacity: 0.72,
};

export const timeSegmentSeparatorStyle: SxProps<Theme> = {
  fontSize: "18px",
  fontWeight: 800,
  lineHeight: 1.2,
  px: 0.25,
};

export const chartContainerStyle: SxProps<Theme> = {
  mt: 4,
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};
